Customer.Dashboard ||= {}

# This class has a selector mechanics, and it's intended to only select tags, but it's coded for selection of another
# lists, like groups; it should inherit from App.SelectView class, for better code consistency

class Customer.Dashboard.SocialContentTagsView extends Backbone.View
  template: JST["backbone/templates/customer/social_content_tags"]

  events:
    'click i.icon-remove': 'onRemove'
    'change select.tags': 'onAdd'
    'chosen:showing_dropdown .tags': 'showDropdown'
    'chosen:hiding_dropdown .tags': 'hideDropdown'
    'click i.save-tags': 'saveEdit'
    'click i.cancel-tags': 'cancelEdit'

  initialize: (@options = {}) ->
    @list = @options.list || []
    @tags = @setTagsByClientCode(@options.tagsByClientCode) || []
    @labels = @options.labels || []
    @onChangeCallback = @options.onChange || () ->
    @canEdit = !!@options.canEdit
    @viewWithSaveButtons = @options.saveButtons
    @placeholder = @options.placeholder || I18n.t('monitoring.dashboard.social_content.tag_editor.add_tag')
    @width = @options.width || 'auto'
    @order = if _.isBoolean(@options.order) then @options.order else true
    @allowsMultiple = if _.isBoolean(@options.allowsMultiple) then @options.allowsMultiple else true

  _convertToObject: (tags) ->
    _.map tags, (tagDescription) =>
      tag = _.find @list, (tag) => tag.description ==  tagDescription
      tag || { description: tagDescription }

  render: (editable=true, change_icon=false) ->
    @deactivateOnBeforeUnloadEvent()
    if @order
      if @list and @list.length > 0
        @list = _.sortBy(@list, (t) -> t.description.toLowerCase())
    labels = _.sortBy(@labels, (label) ->
      if label.toLowerCase then label.toLowerCase() else label
    )
    @$el.html(@template(list: @list, tags: @_convertToObject(@tags), labels: labels, editable: editable, self: this))
    @$el.find('.tags').chosen(width: @width, search_contains: true)
    if @options.shiftPosition then @_shiftTagsAndChosenPosition()
    this

  setList: (list) ->
    @list = list

  setTagsByClientCode: (tags) ->
    @tags = _.map(tags, (tag) => @clientCodeToDescription(tag))

  setLabels: (labels) ->
    @labels = labels

  clientCodeToDescription: (clientCode) ->
    tag = @_findByClientCode(clientCode)
    if tag then tag.description else clientCode

  _findByClientCode: (clientCode) ->
    _.find(@list, (tag) => tag.code == clientCode)

  getTags: ->
    _.map(_.filter(@list, (tag) =>
      @_getCurrentTags().indexOf(tag.description) != -1), (tag) => tag.code)

  getLabels: ->
    _.map(_.filter(@list, (tag) =>
      @_getCurrentLabels().indexOf(tag.description) != -1), (label) => label.description)

  onRemove: (event) =>
    labelName = $($(event.currentTarget).parent().children()[0]).text().trim()

    @previousTags ||= _.clone(@tags)
    @previousLabels ||= _.clone(@labels)

    if (index = @tags.indexOf(labelName)) != -1
      @tags.splice(index, 1);
    else if (index = @labels.indexOf(labelName)) != -1
      @labels.splice(index, 1);

    if @viewWithSaveButtons
      @render()
      @_activateOnBeforeUnloadEvent()
      @$el.find('.tag-controllers').removeClass('hidden')
    else
      $(event.currentTarget).parent().remove()
      @onChangeCallback('remove', _.find(@list, (tag) => tag.description == labelName))
      @render()

  onAdd: (event) =>
    @previousTags ||= _.clone(@tags)
    @previousLabels ||= _.clone(@labels)

    labelId = $(event.currentTarget).val().trim()
    labelName = $(event.currentTarget).find(":selected").text().trim()
    unless @_isAddedYet(labelName) or labelId.trim() == '' or !@enabledToAddMore()
      @_appendToHtml(labelId, labelName)

      if @viewWithSaveButtons
        @render()
        @_activateOnBeforeUnloadEvent()
        @$el.find('.tag-controllers').removeClass('hidden')
      else
        @render()
        @onChangeCallback('add', @_findByClientCode(labelId))

  saveEdit: =>
    askConfirmation = false
    for tag in @list
      tagIsAdded = tag.description in @tags or tag.description in @labels
      if tagIsAdded
        isNewTag = tag.description not in @previousTags and tag.description not in @previousLabels
        if isNewTag and tag.implies_rejection
          askConfirmation = true

    @previousTags = null
    @previousLabels = null
    @$el.find('.tag-controllers').addClass('hidden')
    @deactivateOnBeforeUnloadEvent()
    @onChangeCallback(askConfirmation)

  cancelEdit: =>
    @tags = @previousTags
    @labels = @previousLabels

    @previousTags = null
    @previousLabels = null
    @deactivateOnBeforeUnloadEvent()
    @render()

  _appendToHtml: (labelId, labelName) ->
    innerSpan = $("<span>#{labelName}</span><i class=\"icon-white icon-remove\"></i>")
    labelHtml = $('<span class="label keyword"></span>')
    labelHtml.append(innerSpan)
    if @_isLabel(labelId)
      labelHtml.addClass('social_content_label')
      @labels.push(labelName)
    else
      labelHtml.addClass('social_content_tag')
      labelHtml.append(innerSpan)
      @tags.push(labelName)

    @$el.find('.applied_tags').append(labelHtml)

  _isLabel: (id) ->
    tag = _.find(@list, (tag) -> tag.code.toString() == id)
    tag.type == 'label'

  disabledToAddMore: ->
    !@enabledToAddMore()

  enabledToAddMore: ->
    alreadySelected = @tags.length + @labels.length
    @allowsMultiple || alreadySelected < 1

  _isAddedYet: (label) ->
    @_getCurrentTags().indexOf(label) != -1 or @_getCurrentLabels().indexOf(label) != -1

  _getCurrentTags: ->
    @_getCurrentTextsElements('.social_content_tag')

  _getCurrentLabels: ->
    @_getCurrentTextsElements('.social_content_label')

  _getCurrentTextsElements: (selector) ->
    _.map(@$el.find(selector), (htmlButton) => $(htmlButton).text().trim())

  _shiftTagsAndChosenPosition: ->
    @$el.find(".applied_tags").before(@$el.find(".chosen-container"));

  showDropdown: (event, params) ->
    params.chosen.dropdown.show()

  hideDropdown: (event, params) ->
    params.chosen.dropdown.hide()

  _activateOnBeforeUnloadEvent: ->
    window.onbeforeunload = (e) ->
      message = "You have unsaved tags or keywords. Changes will be lost."
      event = e or window.event
      event.returnValue = message if event
      return message

  deactivateOnBeforeUnloadEvent: ->
    window.onbeforeunload = () ->
